import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { PrimaryButton } from '../../../shared/ui';

type PersonalDataSubmitButtonProps = {
  canSubmit: boolean;
  onSubmit: () => void;
};

const SubmitButton = styled(PrimaryButton).attrs({
  'data-ui': 'registration-identity-personal-data-submit',
})<{ $isDisabled: boolean }>`
  align-self: center;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.4 : 1)};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export function PersonalDataSubmitButton({
  canSubmit,
  onSubmit,
}: PersonalDataSubmitButtonProps) {
  const { t } = useTranslation();

  return (
    <SubmitButton
      $isDisabled={!canSubmit}
      disabled={!canSubmit}
      type="button"
      onClick={onSubmit}
    >
      {t('registrationIdentityPersonalData.cta')}
    </SubmitButton>
  );
}
